import {GET_PRODUCT_LIST_ACTIVE, PRODUCT_ERROR} from './actionTypes';

const initialState = {
  error: '',
  productList: [],
  loading: false,
  refresh: false
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_LIST_ACTIVE:
      state = {
        ...state,
        loading: false,
        error: '',
        productList: action.payload
      };
      break;
    case PRODUCT_ERROR:
      state = {
        ...state,
        loading: false,
        error: action.payload
      };
      break;

    default:
      state = {...state};
      break;
  }
  return state;
};

export default productReducer;
